import {
	Component,
	Input,
	Output,
	EventEmitter,
	OnChanges,
	SimpleChanges,
	ChangeDetectionStrategy,
} from '@angular/core';
import { User } from '@lmc-app/shared/interface/user.interface';
import { MatTabGroup, MatTab, MatTabContent } from '@angular/material/tabs';
import { NotesComponent } from './notes/notes.component';
import { CallComponent } from './call/call.component';
import { EmailComponent } from './email/email.component';
import { NgIf } from '@angular/common';
import { TimelineComponent } from './timeline/timeline.component';

@Component({
	selector: 'app-activities',
	templateUrl: './activities.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./activities.component.scss'],
	imports: [
		MatTabGroup,
		MatTab,
		NotesComponent,
		CallComponent,
		EmailComponent,
		NgIf,
		MatTabContent,
		TimelineComponent,
	],
})
export class ActivitiesComponent implements OnChanges {
	@Input() application: any;
	@Input() applicationId: string;
	@Output() applicationChange = new EventEmitter();
	@Input() currentUser: User;

	ngOnChanges(changes: SimpleChanges) {
		this.application = changes.application?.currentValue;
		if (changes.currentUser?.currentValue) {
			this.currentUser = changes.currentUser?.currentValue;
		}
	}
}
